export default {
    WS_URL:  "dev-gpu.vizorlabs.ru:8001",
    CAMERA_STATUS_UPDATE_INTERVAL: 5000,
}
